import React from "react";
import Modal from "../../../../_components/Modal";
import Button from "../../../../_components/Button";
import Text from "../../../../_components/Text";
import Toast from "../../../../_components/Toast";

import { formatCurrencyValue, decimalFormat } from "../../../../utils";
import { getPlans as get, upgradeBranchPlan } from "../../../../api/plans";
import { CardHorizontal, PlanWrapper, Icon } from "./components";
import { useShowMe } from "./hooks";

import AppContext from "../../context";

export default (props) => {
  const context = React.useContext(AppContext);
  const ref = React.useRef(null);
  const handleShowMe = useShowMe();
  const [title, setTitle] = React.useState("");
  const [toast, setToast] = React.useState({
    show: false,
    message: "",
    type: "",
  });
  const [plans, setPlans] = React.useState([]);
  const [fetchingPlans, setFechtingPlans] = React.useState(false);
  const [upading, setUpdating] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [selectedPlan, setPlan] = React.useState({});

  React.useEffect(() => {
    setShow(handleShowMe(context));
  }, [context.currentBranch, location.pathname]);

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  function getPlans() {
    setFechtingPlans(true);
    get()
      .then((data) => {
        const notesQuantity = context.currentBranch.branch_plan.notes_quantity;
        setTitle(
          `Assinatura atual: ${context.currentBranch.branch_plan.plan_name}`
        );

        setPlans(data.filter(plan => {
          if (plan.notes_quantity > notesQuantity) {
            return {
              ...plan,
              price: parseFloat(plan.price)
            }
          }
        }));
        setShowModal(true);

        setTimeout(() => {
          setFechtingPlans(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setFechtingPlans(false);
        }, 1000);
      });
  }

  function canUpgrade(new_plan_id) {
    setUpdating(true);
    setToast({ show: false, message: "", type: "" });
    upgradeBranchPlan(new_plan_id)
      .then(resp => {
        window.location.href = "/plan/branch-invoices";
        window.open(resp.url, "__blank")
      })
      .catch((error) => {
        setUpdating(false);
        setShowModal(false);
        setPlan({});
        if (error.pending_invoices) {
          setToast({
            show: true,
            message: "Você possui faturas pendentes!",
            type: "error",
          });
        }
      });
  }

  return (
    <div className={`${props.active || show ? "row" : "d-none"}`} ref={ref}>
      <div>
        <Button
        bigButton
        disabled={fetchingPlans}
        loading={fetchingPlans}
        label="Upgrade de Plano"
        rightIcon="fa-star"
        onClick={getPlans} />
      </div>
      {/* <EasyButton
        type="primary"
        disabled={fetchingPlans}
        loading={fetchingPlans}
        label="Upgrade de Plano"
        icon="fas fa-star"
        onClick={getPlans}
      /> */}
      <Modal
        size="xl"
        title="Selecione abaixo o plano"
        onHide={
          upading
            ? null
            : () => {
              setShowModal(false);
              setPlan({});
            }
        }
        show={showModal}
      >
        <Text fontSize="md">{title}</Text>
        <Text fontSize="md">Selecione abaixo o seu novo plano de notas:</Text>
        <CardHorizontal className="py-4 ">
          {plans.map((plan) => {
            const value = formatCurrencyValue(decimalFormat(plan.price));
            return (
              <PlanWrapper
                selected={selectedPlan.id === plan.id}
                disabled={upading}
                onClick={
                  upading
                    ? null
                    : () => {
                      setPlan(plan.id === selectedPlan.id ? {} : plan);
                    }
                }
              >
                <Icon
                  className="fas fa-check"
                  selected={selectedPlan.id === plan.id}
                />
                <p className="text-center">Assinatura:</p>
                <h2>{plan.name}</h2>
                <h4 className="text-center">mensais</h4>
                <h4 className="py-4">{plan.id == '7945dc1a-1722-43db-a92c-59c8c23346e9' ? 'A negociar' : value}</h4>
              </PlanWrapper>
            );
          })}
        </CardHorizontal>
        <div className="my-4">
          {selectedPlan.id ? (
            selectedPlan.id !== "7945dc1a-1722-43db-a92c-59c8c23346e9" && (
              <Text color="danger" align="center" fontSize="1.2em" py="3">
                Atenção! Após confirmação do Upgrade, não será mais possível
                realizar emissão de notas enquanto o novo plano estiver com a
                fatura pendente. Após pagamento, a ativação será liberada
                automaticamente. Deseja contratar um novo plano? Formas de
                pagamento: PIX e cartões de crédito (American Express,
                Mastercard, Visa, Elo)
              </Text>
            )
          ) : (
            <span />
          )}

          <div className="d-flex justify-content-center py-4">

            <Button
              data-id={selectedPlan.id}
              onClick={() => {
                if (!selectedPlan.id || upading) return;

                if (selectedPlan.id === "7945dc1a-1722-43db-a92c-59c8c23346e9") {
                  window.open(
                    'https://wa.me/5511966466526?text=Olá!,+quero+negociar+um+plano+entre+31+e+99+notas+no+Easygestor',
                    "_blank"
                  )
                  return;
                }

                canUpgrade(selectedPlan.id);
              }}
              disabled={!selectedPlan.id || upading}
            >
              Selecionar
            </Button>


          </div>
        </div>
      </Modal>
      <Toast show={toast.show} type={toast.type} message={toast.message} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/CardUpgrade/index.jsx